import * as React from "react";
import type { SVGProps } from "react";

const FacilityNature = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M7.4987 15V17.5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.91012 6.91045L4.41179 9.41135C4.17362 9.64974 4.10247 10.0081 4.23151 10.3194C4.36055 10.6307 4.66437 10.8337 5.00136 10.8337H9.99802C10.335 10.8337 10.6388 10.6307 10.7679 10.3194C10.8969 10.0081 10.8258 9.64973 10.5876 9.41134L8.08926 6.91044C7.76323 6.58584 7.23615 6.58584 6.91012 6.91045V6.91045Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.12607 10.833L11.4714 13.631C11.6794 13.8792 11.7248 14.2253 11.5879 14.5187C11.451 14.8121 11.1565 14.9997 10.8327 14.9997H4.16928C3.8455 14.9997 3.55103 14.8121 3.41412 14.5187C3.2772 14.2253 3.32264 13.8792 3.53063 13.631L5.87596 10.833"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 17.4997H17.5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1667 14.167V17.5003"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.7508 8.75C17.5648 9.74389 17.7314 11.1185 17.1785 12.278C16.6255 13.4376 15.4526 14.1734 14.168 14.1667"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="3.75"
      cy="3.75"
      r="1.25"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.7482 8.74993C17.667 7.61152 17.7344 6.00653 16.9142 4.79513C16.0941 3.58373 14.5789 3.05017 13.1807 3.48039C11.7825 3.91062 10.8293 5.20369 10.832 6.6666"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityNature.displayName = "FacilityNature";

export default FacilityNature;
